import { useKillSwitch as baseUseKillSwitch } from '@cbhq/client-kill-switch';

import { workspaceKillSwitchConfig } from './initKillSwitches';

export const useKillSwitch = baseUseKillSwitch<typeof workspaceKillSwitchConfig>;
